import { render, staticRenderFns } from "./NewCuentasbancarias.vue?vue&type=template&id=f0ceaa5c&scoped=true&"
import script from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
export * from "./NewCuentasbancarias.vue?vue&type=script&lang=ts&"
import style0 from "./NewCuentasbancarias.vue?vue&type=style&index=0&id=f0ceaa5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ceaa5c",
  null
  
)

export default component.exports